// extracted by mini-css-extract-plugin
export default {"container":"signUp_container__i8PMh","card":"signUp_card__KFm8i","forgotPassword":"signUp_forgotPassword__K--MB","link":"signUp_link__5LqQL"};